module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/router.svg?60406ae5a8d2c964ff1ef65069a994ad";